// Desc: Utility service for common functions
class UtilityService {
  // Start date at the beginning of the current year
  fromDateInit() {
    let d = new Date(new Date().getFullYear(), 0, 1);
    let datestring = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(-2)}-${("0" + d.getDate()).slice(-2)} 00:00:00`;
    return datestring;
  }

  // Date for the beginning of a previous year, subtracting 'val' years from the current year
  fromDatePastInit(val) {
    let d = new Date(new Date().getFullYear() - val, 0, 1);
    let datestring = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(-2)}-${("0" + d.getDate()).slice(-2)} 00:00:00`;
    return datestring;
  }

  // Current date and time
  toDateInit() {
    let d = new Date();
    let datestring = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(-2)}-${("0" + d.getDate()).slice(-2)} ${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}:${("0" + d.getSeconds()).slice(-2)}`;
    return datestring;
  }
}

export default new UtilityService();
